import { render } from "./GenericH4.vue?vue&type=template&id=77f290fa&scoped=true"
const script = {}

import "./GenericH4.vue?vue&type=style&index=0&id=77f290fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f290fa"],['__file',"src/components/GenericH4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77f290fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77f290fa', __exports__)) {
    api.reload('77f290fa', __exports__)
  }
  
  module.hot.accept("./GenericH4.vue?vue&type=template&id=77f290fa&scoped=true", () => {
    api.rerender('77f290fa', render)
  })

}


export default __exports__